"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.buttonStyles = exports.baseButtonStyles = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectSpread2"));

var _react = _interopRequireDefault(require("react"));

var _reactTracking = require("react-tracking");

var _stitches = require("../../stitches.config");

var baseButtonStyles = {
  border: '0',
  borderRadius: '$buttonShape$default',
  fontSize: '$normal',
  fontWeight: '$medium',
  marginBottom: '5px',
  marginTop: '5px',
  outline: 'none',
  padding: '16px 15px',
  textAlign: 'center',
  textDecoration: 'none',
  transition: 'background-color .2s',
  '&:hover': {
    cursor: 'pointer'
  },
  '&:disabled': {
    opacity: '0.5'
  }
};
exports.baseButtonStyles = baseButtonStyles;
var buttonStyles = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, baseButtonStyles), {}, {
  variants: {
    buttonShape: {
      square: {
        borderRadius: '$buttonShape$square'
      }
    },
    color: {
      primary: {
        backgroundColor: '$primary',
        color: '$primaryContrast',
        '&:hover:not([disabled])': {
          backgroundColor: '$primaryHover'
        },
        '&:disabled': {
          opacity: '0.5'
        }
      },
      red: {
        backgroundColor: '$red',
        color: '$redContrast',
        '&:hover:enabled': {
          backgroundColor: '$redHover'
        }
      },
      secondary: {
        backgroundColor: '$secondary',
        color: '$secondaryContrast',
        '&:hover:enabled': {
          backgroundColor: '$secondaryHover'
        }
      },
      white: {
        backgroundColor: '$primaryContrast',
        border: '2px solid $primary',
        color: '$primary',
        '&:hover:enabled': {
          backgroundColor: '$primaryHover',
          color: '$primaryContrast'
        }
      }
    }
  }
});
exports.buttonStyles = buttonStyles;
var StyledButton = (0, _stitches.styled)('button', buttonStyles);
/**
 * A basic button that has variants for colors.
 */

var Button = function Button(_ref) {
  var buttonShape = _ref.buttonShape,
      children = _ref.children,
      color = _ref.color,
      disabled = _ref.disabled,
      id = _ref.id,
      name = _ref.name,
      type = _ref.type,
      onClick = _ref.onClick;

  var _useTracking = (0, _reactTracking.useTracking)(),
      trackEvent = _useTracking.trackEvent;

  var handleClick = function handleClick() {
    trackEvent({
      event_name: "".concat(name, "-button"),
      event_type: 'click'
    });
    onClick();
  };

  return /*#__PURE__*/_react.default.createElement(StyledButton, {
    buttonShape: buttonShape,
    color: color,
    disabled: disabled,
    id: id,
    name: name,
    type: type,
    onClick: handleClick
  }, children);
};

Button.defaultProps = {
  buttonShape: 'default',
  color: 'primary',
  disabled: false,
  onClick: function onClick() {},
  type: 'button'
};
var _default = Button;
exports.default = _default;